import { useContext, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { Loader } from "@transfr-inc/dashboard-components";
import { PageLayout } from "@transfr-inc/dashboard-components/layouts";

import { WarningMessages } from "@transfr-inc/dashboard-components";
import { GenericError } from "@components/utils/notification.constants";
import { Category } from "@constants/category.model";
import { MenuBuilderContext } from "@src/context";
import { services } from "@src/dependencies";
import { useNotification } from "@src/hooks";
import { useEditWarningModal } from "@transfr-inc/dashboard-components/hooks";

import { DeleteCategoryModal } from "../menus/detail/components/menu-builder/modals/delete-category/delete-category.modal";
import { EditCategoryModal } from "../menus/detail/components/menu-builder/modals/edit-category/edit-category.modal";
import { MenusSection } from "./components/menus.section";
import { ModulesSection } from "./components/modules.section";
import { CategoryDetailPageHeader } from "./components/page.header";

import "./index.scss";

export const CategoryDetail = () => {
  const { state } = useLocation();
  const { getAllCategories } = useContext(MenuBuilderContext);

  const history = useHistory();
  const { data, breadcrumbLabel } = state;
  const [loading, setLoading] = useState();
  const [openEditCategoryModal, setOpenEditCategoryModal] = useState();
  const [deleteCategoryModalOpen, setDeleteCategoryModalOpen] = useState();
  const [errorDeleteModal, openErrorDeleteModal] = useEditWarningModal({
    title: WarningMessages.category.title,
    message: WarningMessages.category.delete,
    icon: ["fa-solid", "fa-clock-rotate-left"],
    iconColor: "danger-red",
  });
  const { addNotification } = useNotification();
  const [categoryData, setCategoryData] = useState(data);

  const { menuBuilderService } = services;

  const onEditCategoryHandler = async (value) => {
    setCategoryData(value);
    getAllCategories();
  };

  const onDeleteCategoryHandler = async () => {
    setLoading(true);
    try {
      await menuBuilderService.deleteCategory(categoryData.id);
      setLoading();
      setDeleteCategoryModalOpen();
      history.replace("/templates");
    } catch {
      setLoading();
      showNotification(NotificationType.error, GenericError);
    }
  };

  const showNotification = (type, message, icon) => {
    addNotification({ type, message, icon });
  };

  const handleDeleteCategoryClick = () => {
    if (categoryData?.menus?.length === 0) {
      setDeleteCategoryModalOpen(true);
    } else {
      openErrorDeleteModal(true);
    }
  };

  const canEdit = categoryData?.categoryType === Category.INTERNAL_CUSTOM;

  return (
    <PageLayout
      className="category-detail-page"
      header={
        <CategoryDetailPageHeader
          category={categoryData}
          breadcrumb={breadcrumbLabel}
          onEditCategoryClick={() => setOpenEditCategoryModal(true)}
          onDeleteCategoryClick={handleDeleteCategoryClick}
        />
      }
    >
      {loading && <Loader overlay></Loader>}
      <div className="category-detail-body">
        <div className="text-with-info">
          <label>
            Changes made will be automatically propagated to menus provisioned
            with this category <sup>*</sup>
          </label>
        </div>
        <MenusSection category={categoryData} />
        <ModulesSection
          category={categoryData}
          showNotification={showNotification}
          editionEnabled={canEdit}
        />
        {openEditCategoryModal && (
          <EditCategoryModal
            category={categoryData}
            open={openEditCategoryModal}
            onCancel={() => setOpenEditCategoryModal()}
            onEditCategoryHandler={onEditCategoryHandler}
            onDeleteCategoryClickHandler={() => handleDeleteCategoryClick()}
            async
          ></EditCategoryModal>
        )}
        {deleteCategoryModalOpen && (
          <DeleteCategoryModal
            open={deleteCategoryModalOpen}
            onCancel={() => setDeleteCategoryModalOpen()}
            onDeleteCategory={onDeleteCategoryHandler}
            category={categoryData}
          ></DeleteCategoryModal>
        )}
        {errorDeleteModal}
      </div>
    </PageLayout>
  );
};
